<template>
  <span>
    {{ $store.getters.currencySymbol }}
    <slot />
  </span>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
